import {
  DELETE_PAYMENT_INFO,
  DELETE_INTEGRATION_SETTINGS,
  DELETE_TREKKSOFT_CATEGORIES,
  RESET_DELETED_INTEGRATION_SETTINGS
} from 'constants/userSettings';

const initialState = {
  deletedPaymentsSettings: [],
  deletedIntegrationsSettings: [],
  deletedTrekksoftCategories: []
};

const userSettingsReducer = (state = initialState, action) => {
  if (action.type === DELETE_PAYMENT_INFO) {
    {
      return {
        ...state,
        deletedPaymentsSettings: [
          ...new Set(
            state.deletedPaymentsSettings.concat({
              id: action.id,
              paymentSystem: action.paymentSystem
            })
          )
        ]
      };
    }
  } else if (action.type === DELETE_INTEGRATION_SETTINGS) {
    {
      return {
        ...state,
        deletedIntegrationsSettings: [
          ...new Set(
            state.deletedIntegrationsSettings.concat({
              id: action.id,
              integrationPlatform: action.integrationPlatform
            })
          )
        ]
      };
    }
  } else if (action.type === RESET_DELETED_INTEGRATION_SETTINGS) {
    return {
      ...state,
      deletedIntegrationsSettings: []
    };
  } else if (action.type === DELETE_TREKKSOFT_CATEGORIES) {
    return {
      ...state,
      deletedTrekksoftCategories: [
        ...new Set(state.deletedTrekksoftCategories.concat(action.id))
      ]
    };
  } else {
    return {
      ...state
    };
  }
};

export default userSettingsReducer;
